"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FACTOR = exports.ONE_WEEK_S = exports.ONE_DAY_S = exports.TEN_MINUTES_S = exports.FIVE_MINUTES_S = exports.FITEEN_MINUTES_S = exports.FITEEN_MINUTES_M = exports.START_OF_UNITS = exports.units = void 0;
exports.units = {
    second: 'second',
    seconds: 'seconds',
    minute: 'minute',
    minutes: 'minutes',
    hour: 'hour',
    hours: 'hours',
    day: 'day',
    days: 'days',
    week: 'week',
    weeks: 'weeks',
    month: 'month',
    months: 'months',
    year: 'year',
    years: 'years',
};
exports.START_OF_UNITS = {
    second: 'second',
    seconds: 'seconds',
    minute: 'minute',
    minutes: 'minutes',
    hour: 'hour',
    hours: 'hours',
    day: 'day',
    days: 'days',
    week: 'isoWeek',
    weeks: 'isoWeek',
    month: 'month',
    months: 'months',
    year: 'year',
    years: 'years',
};
exports.FITEEN_MINUTES_M = 15;
exports.FITEEN_MINUTES_S = 15 * 60;
exports.FIVE_MINUTES_S = 5 * 60;
exports.TEN_MINUTES_S = 10 * 60;
exports.ONE_DAY_S = 86400;
exports.ONE_WEEK_S = 604800;
exports.FACTOR = 1000;
